module.exports = __webpack_public_path__ + "static/media/nativescript.835462e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/nativescript.png
// module id = 152
// module chunks = 0